module.exports = __webpack_public_path__ + "static/img/award7.069e854.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/award7.jpg
// module id = Y7mV
// module chunks = 1